<template>
    <div class="card_container">
        <div v-if="!imageLoaded" class="img_loader">
            <van-loading color="#fff" type="spinner" size="24px" />
        </div>
        <img :src="props.gameImage" class="gameCard" :style="{ visibility: imageLoaded ? 'visible' : 'hidden' }" alt=""
            @load="onImageLoad" @error="onImageError" @click="gameClickHandle" />
        <div class="heart_icon" @click="addToFavorite">
            <img v-if="gameIsFavoriteLocal == 1" src="@/assets/games/favorite_active.png" alt="">
            <img v-else src="@/assets/games/favorite.png" alt="">
        </div>
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import { useGameStore } from '@/stores/games';
import { toggleFavorite } from '@/view/game/supportScript';

const emits = defineEmits(['clickGameCard', 'updateGameCategories']);
const statusRef = ref();
const isSuccess = ref(false);
const toastContent = ref('');
const loadingRef = ref();
const userStore = useUserStore()
const imageLoaded = ref(false);
const gameStore = useGameStore()
const props = defineProps({
    gameImage: {
        type: String,
        default: () => ''
    },
    gameTypeId: {
        type: [Number, String],
    },
    gameIsFavorite: {
        type: Number
    }
});
const gameIsFavoriteLocal = ref(props.gameIsFavorite);

watch(() => props.gameIsFavorite, (newVal: any) => {
    gameIsFavoriteLocal.value = newVal
})
watch(() => props.gameImage, () => {
    imageLoaded.value = false;
})
const gameClickHandle = () => {
    emits('clickGameCard')
}
const onImageLoad = (e: Event) => {
    imageLoaded.value = true;
};

const onImageError = () => {
    imageLoaded.value = true;
};

const addToFavorite = () => {
    loadingRef.value.open()
    toggleFavorite({
    userId: userStore.id,
    gameId: props.gameTypeId || '',
    currentStatus: gameIsFavoriteLocal.value || '',
    loadingRef,
    onSuccess: (status, msg) => {
        loadingRef.value.close()
      gameIsFavoriteLocal.value = status;
      showSuccess(msg || '');
      gameStore.getGameGroupListData();
      emits('updateGameCategories')
    },
    onError: (msg) => {
         loadingRef.value.close()
        showError(msg)}
  });
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

</script>
<style scoped>
.card_container {
  display: flex;
  justify-content: right;
  width: 100%;
  height: 100%;
  position: relative; 
}


.card_container img {
    border-radius: 10px;
    width: 100%;
}

.gameCard {
    width: 100%;
    /* height: 11.5rem; */
    /* object-fit: cover; */
    display: block;
}

.heart_icon {
    background: #000000a8;
    border-radius: 30px;
    padding: 5px;
    margin: 5px 0px 5px -30px;
    height: 15px;
}

.heart_icon img {
    width: 15px;
}

/* .image_wrapper {
  position: relative;
  width: 100%;
  height: 100%;
} */

.img_loader {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
}
</style>